module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"deleteReportDialog.events.successfulDeletion":"Successfully deleted the report \u0027{reportName}\u0027","deleteReportDialog.title":"Delete Report","deleteReportDialog.subtitle":"Please enter the name of this report to delete it"}}')
  delete Component.options._Ctor
}
